export const TypeDiscount = {
  porcentagem: 'Porcentagem',
  valorMonetario: 'Valor Monetário'
}